// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
	FILE: _core.scss

	USED ON:
		- srprs.me/*

	USAGE:
		Meant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1

	NOTES:
		NEVER use @import "base/*"; or such, read this => http://stackoverflow.com/a/4779432
*/
.clearfix {
  overflow: auto;
}

.display-flex {
  display: inline;
}
@media only screen and (min-width: 767px) {
  .display-flex {
    display: flex;
  }
}

.full-width {
  width: 100%;
}

@media only screen and (max-width: 767px) {
  .mobile-full-width {
    width: 100%;
  }
}

@media only screen and (min-width: 767px) {
  .width-49 {
    width: 49%;
  }
}

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}

.margin-b-s {
  margin-bottom: 10px;
}

.margin-b-m {
  margin-bottom: 20px;
}

.margin-b-l {
  margin-bottom: 40px;
}

.padding-t-s {
  padding-top: 10px;
}

.padding-t-s-7 {
  padding-top: 7px;
}

.padding-l-s {
  padding-left: 10px;
}

.padding-r-s {
  padding-right: 10px;
}

.padding-r-m {
  padding-right: 20px;
}

.padding-r-xl {
  padding-right: 60px;
}

.text-centered {
  text-align: center;
}

.text-bold {
  font-weight: bold;
}

.text-small {
  font-size: 14px;
}

.text-medium {
  font-size: 20px;
}

.text-large {
  font-size: 24px;
}

.text-xlarge {
  font-size: 28px;
}

.text-uppercase {
  text-transform: uppercase;
}

.is-loading,
.loading {
  color: #ececec;
  background-color: #ececec;
}
.is-loading::selection, .is-loading::-moz-selection,
.loading::selection,
.loading::-moz-selection {
  background: #ececec;
}

@media screen and (max-width: ) {
  body:before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 375px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 640px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 768px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1024px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1280px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1440px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1600px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
/*
	usage:

	.element {
		@include browserfix(ie) {
			&:after {
				content: "This is IE only"
			}
		}
		@include browserfix(firefox) {
			&:after {
				content: "Only Firefox users will see this";
			}
		}
	}
*/
@keyframes buttonDisabled {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
.srprs-formBox {
  position: relative;
  background-color: #fff;
  padding: 19px 15px;
}
.srprs-formBox.with-shadow {
  box-shadow: 0 0 12px 0 rgba(34, 34, 34, 0.15);
}
.srprs-formBox.huge {
  padding: 10px 26px 35px;
}
.srprs-formBox.huge .srprs-button {
  margin-left: 0;
}
.srprs-formBox.huge .srprs-buttonExtended {
  border-bottom: none;
}
.srprs-formBox.huge .wrapper-inner {
  border-left: 2px solid rgba(0, 0, 0, 0.25);
  padding-left: 24px;
}
.srprs-formBox.expanded {
  padding: 29px 15px;
}
.srprs-formBox.expanded .srprs-formBox-button {
  text-align: right;
  padding-right: 15px;
}
.srprs-formBox.right-stick {
  padding-right: 0;
}
.srprs-formBox.has-link {
  margin-bottom: 10px;
}
.srprs-formBox .form-element-wrapper {
  margin-bottom: 15px;
}
.srprs-formBox .srprs-button {
  margin-left: -15px;
}
.srprs-formBox .srprs-button:hover {
  transform: none;
}
.srprs-formBox .srprs-buttonExtended {
  text-transform: uppercase;
  border-bottom: 1px solid #e7e7e7;
}
.srprs-formBox .srprs-buttonExtended:last-child {
  border-bottom: none;
  margin-bottom: 12px;
}
.srprs-formBox .srprs-buttonExtended .wrapper-icon {
  padding-left: 20px;
}
.srprs-formBox .srprs-buttonExtended .wrapper-right {
  padding-right: 20px;
}

@media screen and (min-width: 1024px) {
  .srprs-formBox {
    display: flex;
    align-items: center;
    width: 100%;
  }
  .srprs-formBox.huge {
    padding: 31px 21px 31px 39px;
    max-width: 1199px;
  }
  .srprs-formBox.huge .srprs-button {
    margin-left: 15px;
  }
  .srprs-formBox.huge .wrapper-inner {
    border-left: none;
    padding-left: 0;
  }
  .srprs-formBox.expanded .srprs-formBox-button {
    padding-right: 0;
  }
  .srprs-formBox .srprs-formBox-form {
    display: flex;
    width: 100%;
  }
  .srprs-formBox .srprs-formBox-button {
    flex: 1;
  }
  .srprs-formBox .form-element-wrapper {
    width: 50%;
    margin-bottom: 0;
    padding-right: 10px;
  }
  .srprs-formBox .srprs-buttonExtended {
    border-bottom: none;
    border-right: 1px solid #e7e7e7;
    width: 49%;
    margin-bottom: 0;
    margin-top: 0;
  }
  .srprs-formBox .srprs-buttonExtended:last-child {
    border-right: none;
  }
  .srprs-formBox .srprs-buttonExtended + .srprs-buttonExtended {
    margin-top: 0;
    margin-bottom: 0;
    margin-right: 2%;
  }
  .srprs-formBox .srprs-button.type-plain {
    height: 64px;
    padding-right: calc(var(--sizeRegular) - 15px - var(--borderWidth));
    padding-left: 43px;
    margin-left: 10px;
    margin-right: -15px;
  }
  .srprs-formBox .srprs-button.type-primary {
    padding-right: calc(var(--sizeRegular) - 15px - var(--borderWidth));
    padding-left: 43px;
    border-top-right-radius: 0;
    border-top-left-radius: calc(var(--sizePrimary) / 2);
    border-bottom-right-radius: 0;
    border-bottom-left-radius: calc(var(--sizePrimary) / 2);
    margin-left: 10px;
    margin-right: -15px;
  }
}`, "",{"version":3,"sources":["webpack://./../srprsme-react-components/src/components/_Assets/scss/_core.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/_helpers.scss","webpack://./../srprsme-react-components/src/components/FormBox/FormBox.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_breakpoint.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_browser-fixes.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/animations/_Button.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/repeatables/_box-shadow.scss"],"names":[],"mappings":"AAEA;;;;;;;;;;;CAAA;ACAA;EACE,cAAA;ACWF;;ADRA;EACE,eAAA;ACWF;ADVE;EAFF;IAGI,aAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADTE;EADF;IAEI,WAAA;ECaF;AACF;;ADTE;EADF;IAEI,UAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADVA;EACE,YAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADVA;EACE,gBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADXA;EACE,eAAA;ACcF;;ADZA;EACE,eAAA;ACeF;;ADbA;EACE,eAAA;ACgBF;;ADdA;EACE,eAAA;ACiBF;;ADfA;EACE,yBAAA;ACkBF;;ADfA;;EAEE,cAAA;EACA,yBAAA;ACkBF;ADjBE;;;EAEE,mBAAA;ACoBJ;;ACpFA;EAEI;IACE,iBAAA;IACA,aAAA;EDsFJ;AACF;ACvHI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDoEN;AACF;AC7HI;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED0EN;AACF;ACnII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDgFN;AACF;ACzII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDsFN;AACF;AC/II;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED4FN;AACF;ACrJI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDkGN;AACF;AC3JI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDwGN;AACF;AEzIA;;;;;;;;;;;;;;;CAAA;AChCA;EACE;IAEE,kCAAA;EH0LF;EGxLA;IAEE,iCAAA;EHyLF;EGvLA;IAGE,kCAAA;EHuLF;EGrLA;IAEE,iCAAA;EHsLF;AACF;AArMA;EAIE,kBAAA;EAEE,sBAAA;EAEF,kBAAA;AAkMF;AAzME;EISE,6CAAA;AJmMJ;AAnME;EACE,uBAAA;AAqMJ;AApMI;EACE,cAAA;AAsMN;AApMI;EACE,mBAAA;AAsMN;AApMI;EACE,0CAAA;EACA,kBAAA;AAsMN;AAlME;EACE,kBAAA;AAoMJ;AAlMI;EACE,iBAAA;EAEE,mBAAA;AAmMR;AA/LE;EAEI,gBAAA;AAgMN;AA7LE;EAEI,mBAAA;AA8LN;AA3LE;EAEI,mBAAA;AA4LN;AAxLE;EAEI,kBAAA;AAyLN;AAvLI;EACE,eAAA;AAyLN;AApLE;EAEI,yBAAA;EAGA,gCAAA;AAmLN;AAjLI;EAEI,mBAAA;EAGA,mBAAA;AAgLR;AA7KI;EACE,kBAAA;AA+KN;AA7KI;EACE,mBAAA;AA+KN;;AC5PI;EDmFF;IACE,aAAA;IACA,mBAAA;IACA,WAAA;EA6KF;EA3KE;IACE,4BAAA;IACA,iBAAA;EA6KJ;EA5KI;IACE,iBAAA;EA8KN;EA5KI;IACE,iBAAA;IACA,eAAA;EA8KN;EAzKI;IAEI,gBAAA;EA0KR;EAtKE;IACE,aAAA;IACA,WAAA;EAwKJ;EArKE;IACE,OAAA;EAuKJ;EArKE;IACE,UAAA;IACA,gBAAA;IACA,mBAAA;EAuKJ;EArKE;IAEI,mBAAA;IACA,+BAAA;IAEF,UAAA;IAEE,gBAAA;IACA,aAAA;EAoKN;EAlKI;IAEI,kBAAA;EAmKR;EAhKI;IAEI,aAAA;IACA,gBAAA;IACA,gBAAA;EAiKR;EA5JI;IACE,YAAA;IAEE,mEAAA;IACA,kBAAA;IAGA,iBAAA;IACA,mBAAA;EA2JR;EAxJI;IAEI,mEAAA;IACA,kBAAA;IAGA,0BAAA;IACA,oDAAA;IACA,6BAAA;IACA,uDAAA;IAGA,iBAAA;IACA,mBAAA;EAqJR;AACF","sourcesContent":["@charset \"UTF-8\";\n\n/*\n\tFILE: _core.scss\n\n\tUSED ON:\n\t\t- srprs.me/*\n\n\tUSAGE:\n\t\tMeant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1\n\n\tNOTES:\n\t\tNEVER use @import \"base/*\"; or such, read this => http://stackoverflow.com/a/4779432\n*/\n\n// vars & helpers\n@import 'helpers/variables';\n@import 'helpers/helpers';\n\n// functions\n@import 'helpers/functions/map-deep-get';\n@import 'helpers/functions/color';\n@import 'helpers/functions/font';\n//@import \"helpers/functions/padding\";\n@import 'helpers/functions/section';\n@import 'helpers/functions/str-replace';\n@import 'helpers/functions/z-index';\n\n// mixins\n@import 'helpers/mixins/arrow';\n@import 'helpers/mixins/aspect-ratio';\n@import 'helpers/mixins/breakpoint';\n@import 'helpers/mixins/browser-fixes';\n@import 'helpers/mixins/color-schemes';\n@import 'helpers/mixins/grid';\n@import 'helpers/mixins/no-bullets';\n@import 'helpers/mixins/clearfix';\n@import 'helpers/mixins/font-face';\n@import 'helpers/mixins/scrollbars';\n@import 'helpers/mixins/transform-center';\n@import 'helpers/mixins/transition';\n@import 'helpers/mixins/truncate';\n\n// repeatables (aka think DRY and store it in an @mixin)\n@import 'helpers/repeatables/box-shadow';\n@import 'helpers/repeatables/iphonex';\n@import 'helpers/repeatables/wrapper-inner';\n\n// animations\n@import 'animations/Button';\n","@charset \"UTF-8\";\n\n.clearfix {\n  overflow: auto;\n}\n\n.display-flex {\n  display: inline;\n  @media only screen and (min-width: 767px) {\n    display: flex;\n  }\n}\n\n.full-width {\n  width: 100%;\n}\n\n.mobile-full-width {\n  @media only screen and (max-width: 767px) {\n    width: 100%;\n  }\n}\n\n.width-49 {\n  @media only screen and (min-width: 767px) {\n    width: 49%;\n  }\n}\n\n.pull-left {\n  float: left;\n}\n\n.pull-right {\n  float: right;\n}\n\n.margin-b-s {\n  margin-bottom: 10px;\n}\n\n.margin-b-m {\n  margin-bottom: 20px;\n}\n\n.margin-b-l {\n  margin-bottom: 40px;\n}\n\n.padding-t-s {\n  padding-top: 10px;\n}\n\n.padding-t-s-7 {\n  padding-top: 7px;\n}\n\n.padding-l-s {\n  padding-left: 10px;\n}\n\n.padding-r-s {\n  padding-right: 10px;\n}\n\n.padding-r-m {\n  padding-right: 20px;\n}\n\n.padding-r-xl {\n  padding-right: 60px;\n}\n\n.text-centered {\n  text-align: center;\n}\n\n.text-bold {\n  font-weight: bold;\n}\n.text-small {\n  font-size: 14px;\n}\n.text-medium {\n  font-size: 20px;\n}\n.text-large {\n  font-size: 24px;\n}\n.text-xlarge {\n  font-size: 28px;\n}\n.text-uppercase {\n  text-transform: uppercase;\n}\n\n.is-loading,\n.loading {\n  color: #ececec;\n  background-color: #ececec;\n  &::selection,\n  &::-moz-selection {\n    background: #ececec;\n  }\n}\n","@charset \"UTF-8\";\n\n@import '../_Assets/scss/core';\n\n.srprs-formBox {\n  &.with-shadow {\n    @include box-shadow();\n  }\n  position: relative;\n  background: {\n    color: color(white);\n  }\n  padding: 19px 15px;\n\n  &.huge {\n    padding: 10px 26px 35px;\n    .srprs-button {\n      margin-left: 0;\n    }\n    .srprs-buttonExtended {\n      border-bottom: none;\n    }\n    .wrapper-inner {\n      border-left: 2px solid rgba(0, 0, 0, 0.25);\n      padding-left: 24px;\n    }\n  }\n\n  &.expanded {\n    padding: 29px 15px;\n\n    .srprs-formBox-button {\n      text-align: right;\n      padding: {\n        right: 15px;\n      }\n    }\n  }\n  &.right-stick {\n    padding: {\n      right: 0;\n    }\n  }\n  &.has-link {\n    margin: {\n      bottom: 10px;\n    }\n  }\n  .form-element-wrapper {\n    margin: {\n      bottom: 15px;\n    }\n  }\n\n  .srprs-button {\n    margin: {\n      left: -15px;\n    }\n    &:hover {\n      transform: none;\n    }\n    &.type-plain {\n    }\n  }\n  .srprs-buttonExtended {\n    text: {\n      transform: uppercase;\n    }\n    border: {\n      bottom: 1px solid color(grey-light);\n    }\n    &:last-child {\n      border: {\n        bottom: none;\n      }\n      margin: {\n        bottom: 12px;\n      }\n    }\n    .wrapper-icon {\n      padding-left: 20px;\n    }\n    .wrapper-right {\n      padding-right: 20px;\n    }\n  }\n}\n\n@include breakpoint(tablet-landscape) {\n  .srprs-formBox {\n    display: flex;\n    align-items: center;\n    width: 100%;\n\n    &.huge {\n      padding: 31px 21px 31px 39px;\n      max-width: 1199px;\n      .srprs-button {\n        margin-left: 15px;\n      }\n      .wrapper-inner {\n        border-left: none;\n        padding-left: 0;\n      }\n    }\n\n    &.expanded {\n      .srprs-formBox-button {\n        padding: {\n          right: 0;\n        }\n      }\n    }\n    .srprs-formBox-form {\n      display: flex;\n      width: 100%;\n    }\n\n    .srprs-formBox-button {\n      flex: 1;\n    }\n    .form-element-wrapper {\n      width: 50%;\n      margin-bottom: 0;\n      padding-right: 10px;\n    }\n    .srprs-buttonExtended {\n      border: {\n        bottom: none;\n        right: 1px solid color(grey-light);\n      }\n      width: 49%;\n      margin: {\n        bottom: 0;\n        top: 0;\n      }\n      &:last-child {\n        border: {\n          right: none;\n        }\n      }\n      & + .srprs-buttonExtended {\n        margin: {\n          top: 0;\n          bottom: 0;\n          right: 2%;\n        }\n      }\n    }\n    .srprs-button {\n      &.type-plain {\n        height: 64px;\n        padding: {\n          right: calc((var(--sizeRegular) - 15px) - var(--borderWidth));\n          left: 43px;\n        }\n        margin: {\n          left: 10px;\n          right: -15px;\n        }\n      }\n      &.type-primary {\n        padding: {\n          right: calc((var(--sizeRegular) - 15px) - var(--borderWidth));\n          left: 43px;\n        }\n        border: {\n          top-right-radius: 0;\n          top-left-radius: calc(var(--sizePrimary) / 2);\n          bottom-right-radius: 0;\n          bottom-left-radius: calc(var(--sizePrimary) / 2);\n        }\n        margin: {\n          left: 10px;\n          right: -15px;\n        }\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n$breakpoints: map-deep-get($srprsreactwebsite-config, 'breakpoints');\n\n@mixin breakpoint($screensize) {\n  @if map-has-key($breakpoints, $screensize) {\n    @media screen and (min-width: map-get($breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (min-width: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$height-breakpoints: map-deep-get(\n  $srprsreactwebsite-config,\n  'height-breakpoints'\n);\n\n@mixin height-breakpoint($screensize) {\n  @if map-has-key($height-breakpoints, $screensize) {\n    @media screen and (max-height: map-get($height-breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (max-height: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$breakpoint-initial: map-deep-get(\n  $srprsreactwebsite-config,\n  'breakpoints',\n  's'\n);\n@media screen and (max-width: $breakpoint-initial) {\n  body {\n    &:before {\n      content: 'mobile';\n      display: none;\n    }\n  }\n}\n\n@each $breakpoint, $screensize in $breakpoints {\n  @include breakpoint(#{$screensize}) {\n    body {\n      &::before {\n        @if $breakpoint ==\n          l or\n          $breakpoint ==\n          xl or\n          $breakpoint ==\n          xxl or\n          $breakpoint ==\n          xxxl\n        {\n          content: 'desktop';\n        } @else if $breakpoint == m {\n          content: 'tablet';\n        } @else {\n          content: 'mobile';\n        }\n        display: none;\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n// we should thank http://browserhacks.com/ for this great roundup of dirt\n\n@mixin browserfix($browser) {\n  @if ($browser == 'ie') {\n    // the allmighty IE, 10 and up. 9 and lower requires usage of conditional comments, just stash your code in assets/styles/ie.scss\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n      @content;\n    }\n  } @else if ($browser == 'firefox') {\n    // firefox 3 and up\n    @-moz-document url-prefix() {\n      @content;\n    }\n  } @else if ($browser == 'opera') {\n    // opera 9.5 and up\n    _:-o-prefocus,\n    body:last-child .selector {\n      @content;\n    }\n  } @else if ($browser == 'safari') {\n    // all safari\n    .selector:not(*:root) {\n      @content;\n    }\n  } @else if ($browser == 'chrome') {\n    // chrome 28 and up\n    @supports (-webkit-appearance: none) {\n      @content;\n    }\n  }\n}\n\n/*\n\tusage:\n\n\t.element {\n\t\t@include browserfix(ie) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"This is IE only\"\n\t\t\t}\n\t\t}\n\t\t@include browserfix(firefox) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"Only Firefox users will see this\";\n\t\t\t}\n\t\t}\n\t}\n*/\n","@charset \"UTF-8\";\n\n@keyframes buttonDisabled {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0);\n  }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0);\n  }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0);\n  }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0);\n  }\n}\n","@charset \"UTF-8\";\n\n$box-shadow: map-deep-get($srprsreactwebsite-config, 'box-shadow');\n\n@mixin box-shadow(\n  $blur: map-deep-get($srprsreactwebsite-config, 'box-shadow', 'blur-default')\n) {\n  @if map-has-key($box-shadow, $blur) {\n    box-shadow: 0\n      0\n      map-deep-get($srprsreactwebsite-config, 'box-shadow', $blur)\n      0\n      rgba(color(black), 0.15);\n  } @else {\n    box-shadow: 0\n      0\n      map-deep-get($srprsreactwebsite-config, 'box-shadow', 'blur-default')\n      0\n      rgba(color(black), 0.15);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
